// src/lib/contact.ts
// Contact details for the landing page — the single source for the phone
// number, the forms-backend project id and the Turnstile site key.
//
// The number below is Kaizaar's for now. To switch the page to Baraa's, change
// CONTACT_PHONE_E164 and nothing else: every link is derived from it and the
// number is never rendered as visible text.

/** Digits only, country code first, no plus sign (the wa.me format). */
export const CONTACT_PHONE_E164 = '97336155105'

/** Project the landing page's contact form posts to in the SiteGenius forms backend. */
export const LANDING_PROJECT_ID = '39324c5d-97f9-4ee1-8264-afb9f7276017'

/**
 * Cloudflare Turnstile site key. Public by design (it ships in page HTML), so it
 * is hard-coded. Value: `secret get sitegenius/turnstile-site-key`.
 */
export const TURNSTILE_SITE_KEY = '0x4AAAAAAC_KP6u42qBMfbn_'

/** Message pre-filled in the visitor's WhatsApp chat. */
export const WHATSAPP_PREFILL =
  "Hi SiteGenius, I'd like to talk about an IT project."

/**
 * A wa.me chat link to the one number with `text` prefilled. The text is the only
 * thing that varies between WhatsApp links, and encodeURIComponent keeps any `?`,
 * `&`, `#` or `%` in it from opening a second query or a fragment.
 */
function whatsappHref(text: string): string {
  return `https://wa.me/${CONTACT_PHONE_E164}?text=${encodeURIComponent(text)}`
}

export const WHATSAPP_HREF = whatsappHref(WHATSAPP_PREFILL)

/**
 * WhatsApp link whose prefilled message names a topic, for the per-group "Ask on
 * WhatsApp" buttons: `Hi SiteGenius, I'd like to ask about <topic>.` Stray whitespace
 * in the topic is tidied; an empty topic falls back to the generic message.
 */
export function whatsappHrefFor(topic: string): string {
  const name = topic.trim().replace(/\s+/g, ' ')
  if (name === '') return WHATSAPP_HREF
  return whatsappHref(`Hi SiteGenius, I'd like to ask about ${name}.`)
}

export const TEL_HREF = `tel:+${CONTACT_PHONE_E164}`
